// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

common.View.create('galaxy::habitats.website.layouts.main.Header', {

    swiper: null,

    onDOMLoad() {
        this.initSlider();
        this.initSwipers();
        this.initScrollNavigation();
        this.onPageLoaded();
    },

    initSlider()
    {
        this.element.find('.slider')
            .owlCarousel({
                items: 1,
                nav: false,
                dots: false,
            });
    },

    initSwipers()
    {
        this.swiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            freeMode: true,
            watchOverflow: true,

            // Navigation arrows
            navigation: {
                prevEl: '.swiper1 .swiper-button-prev',
                nextEl: '.swiper1 .swiper-button-next',
            },
        });

        let swiper2 = new Swiper('.swiper-slider', {
            slidesPerView:'auto',
            spaceBetween: 30,
            watchOverflow: true,

            on: {
                init: () => {
                    setTimeout(() => {
                        this.element.find('.swiper2 .swiper-slide').removeClass('tw-opacity-0');
                        this.element.find('.swiper2 .fa-circle-notch').fadeOut();
                    }, 1);
                },
            },

            // If we need pagination
            pagination: {
                el: '.swiper2 .swiper-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                prevEl: '.swiper2 .swiper-button-prev',
                nextEl: '.swiper2 .swiper-button-next',
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3
                }
            }
        });
    },

    async initScrollNavigation()
    {
        // Get elements for scroll nav
        let mainNavLinks = this.element.find('.themeslider a').get(),
            mainSections = this.element.find('[class$="common-Canvas"] > *').get(),
            headerHeight = $('header > :visible:first').outerHeight() + this.element.find('.themeslider').outerHeight() + 30;

        // On scroll
        window.addEventListener('scroll', event => {
            // Get scroll height
            let fromTop = window.scrollY;

            // Go through nav links
            mainNavLinks.forEach(link => {
                // Find section based on css selector
                let sectionItems = $('[class$="common-Canvas"]').find( '[id="' + link.hash.replace( /(-|:|\.|\[|\]|,|=|@)/g, '\\$1' ).replace('#', '') + '"]' ),
                    active = false;

                // Loop items (since multiple canvas can have an id)
                $(sectionItems).each((index, section) => {
                    // Check if scrolled to next section
                    if (
                        section &&
                        fromTop > $(section).offset().top - headerHeight &&
                        fromTop < $(section).offset().top + $(section).outerHeight() -headerHeight
                    ) {
                        active = true;
                    }
                });

                // Check if scrolled to next section
                if ( active ) {
                    // Set active variable
                    link.classList.add('active');

                    // Slide swiper slider
                    this.swiper.slideTo( $(link).parent().index() , false, false );
                } else {
                    link.classList.remove('active');
                }
            });
        });

        // On click, scroll to items
        /*
        $(mainNavLinks).on('click', (event) => {
            // Scroll to item
            this.scrollToItem(event.currentTarget);

            // Is homepage? Then do current action else redirect to home page
            if( window.location.pathname === '/' ) {
                return false;
            }
        });
        */
    },

    scrollToItem(element)
    {
        // Find section based on css selector
        let section = $('[class$="common-Canvas"]').find( '[id="' + element.hash.replace( /(-|:|\.|\[|\]|,|=|@)/g, '\\$1' ).replace('#', '') + '"]' ).get(0),
            headerHeight = $('header > :visible:first').outerHeight() + this.element.find('.themeslider').outerHeight() + 30;

        // Section found?
        if( section ) {
            // Get scroll top
            let scrollTop = $(section).offset().top - headerHeight + 1;

            // Scroll to item
            $('html, body')
                .animate({scrollTop: scrollTop}, 0);
        }
    },

    onPageLoaded()
    {
        window.addEventListener('load', () => {
            this.scrollToItem(window.location, true);
        });
    },

});
